import { render, staticRenderFns } from "./MealPrepInstructions.vue?vue&type=template&id=367e7d0a&"
import script from "./MealPrepInstructions.vue?vue&type=script&lang=js&"
export * from "./MealPrepInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports